import { type FC, useState } from "react";
import { useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../Buttons/Button";

interface Props {
    onNew: (name: string) => Promise<void>;
}

export const FolderCreateDialog: FC<Props> = ({ onNew }) => {
    const dispatch = useShopfrontDispatch();

    const [ name, setName ] = useState("");

    const onCreateClick = () => {
        onNew(name)
            .then(() => {
                dispatch(hideDialog());
            });
    };

    return (
        <div>
            <p>What should the directory be called?</p>
            <input
                type="text"
                value={name}
                onChange={e => {
                    setName(e.currentTarget.value);
                }}
                autoFocus
            />
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-add" ]}
                    disabled={name.length === 0}
                    onClick={onCreateClick}
                >
                    Create
                </Button>
            </div>
        </div>
    );
};
